import { FormControlLabel, Radio } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { FormRadioGroup } from "../../../../../components/fields";
import { VehicleType } from "../../../../../types";
import { stepState } from "../../../recoil";
import { IFormValues, InsertBookingStep } from "../../../types";

const FormVehicleCategory = () => {

    const { t } = useTranslation('booking');

    const step = useRecoilValue(stepState);

    return (
        <FormRadioGroup<IFormValues>
            name="basicDetails.vehicleCategory"
            label={t('label.vehicleType')}
        >
            <FormControlLabel
                value={VehicleType.CAR}
                label={t('label.car')}
                control={<Radio disabled={step === InsertBookingStep.CUSTOMER_DETAILS} />}
            />
            <FormControlLabel
                value={VehicleType.VAN}
                label={t('label.van')}
                control={<Radio disabled={step === InsertBookingStep.CUSTOMER_DETAILS} />}
            />
        </FormRadioGroup >
    )
};

export default FormVehicleCategory;